<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Logo" });
import "tailwindcss/tailwind.css";
import Icon from "../icon/Icon.svelte";
import { Link } from "svelte-navigator";
export let to = "/auctions";
</script>

<div class = 's8-logo'>

    <Link { to }>
        <Icon key = 'smatch' />
        <span>smatch</span>
    </Link>

</div>

<style>
    div.s8-logo :global(a) {
            display: flex;
            align-items: center;
            text-decoration: none;
        }

        div.s8-logo :global(svg) {
            height: 25px;
            margin-right: 4px;
        }

        div.s8-logo span {
            font-weight: 600;
            font-size: 24px;
            line-height: 15px;
        }</style>